var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgCampaignsActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7437 9.38128C17.0854 9.72299 17.0854 10.277 16.7437 10.6187L10.6187 16.7437C10.277 17.0854 9.72299 17.0854 9.38128 16.7437L3.25628 10.6187C3.0854 10.4478 2.99997 10.2239 3 9.99989V5.625C3 4.17525 4.17525 3 5.625 3H10.0002C10.2241 3.00006 10.4479 3.08549 10.6187 3.25628L16.7437 9.38128ZM5.625 6.5C6.10825 6.5 6.5 6.10825 6.5 5.625C6.5 5.14175 6.10825 4.75 5.625 4.75C5.14175 4.75 4.75 5.14175 4.75 5.625C4.75 6.10825 5.14175 6.5 5.625 6.5Z",
    fill: "#525252"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignsActive);
export default __webpack_public_path__ + "static/media/campaigns-active.fa9dcc110bf29bc95d12c2ef5e3ecaf1.svg";
export { ForwardRef as ReactComponent };